import {
  IEasyfyEvent,
  IDataMapper,
  IEasyfyEventExporter,
} from "@shared/easyfy.events/easyfy.eventdata";

/* Kevel Exporter class */
export class KevelEventExporter implements IEasyfyEventExporter {
  mapper: IDataMapper;
  WithMapper(mapper: IDataMapper): void {
    this.mapper = mapper;
  }

  async RegisterEvent(event: IEasyfyEvent): Promise<any> {
    return new Promise<void>(async (resolve) => {
      if (this.mapper) {
        await this.mapper.MapEventData(event);
      }
      resolve();
    });
  }
}
